import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {URLSearchParams} from '@angular/http';
import {CommonModule} from '@angular/common';
import {Observable} from 'rxjs/Observable';
import {Injectable} from '@angular/core';
import {Component} from '@angular/core';
import {Router, ActivatedRoute, RouterModule} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import * as myGlobals from '../globals';
@Injectable()
export class ApiService {
    public token: any;
    constructor(
        private http: Http,
        private router: Router, private authenticationService: AuthenticationService
    ) {
        // if(JSON.parse(localStorage.getItem('currentUser')) === null){
        //   this.router.navigate(['account/login']);
        //   this.token = "";
        // }
        // else
        //   this.token = JSON.parse(localStorage.getItem('currentUser')).token;
    }

    //
    // get_user_token(){
    //   // thistoken = false;
    //   if(localStorage.getItem('currentUser') === null){
    //     return "";
    //   }
    //
    //   return this.token;
    // }




    // checkTokenValid(){
    //   return this.http.get('/api/isloggedin')
    //     .map((res: Response) => {
    //       return (this.callApi(res));
    //     }).catch((error: any) => {
    //       return (this.callApiCatch(error));
    //     });
    // }
    token_middleware() {

        let headers = new Headers({'Authorization': 'Bearer ' + this.authenticationService.token});
        let options = new RequestOptions({headers: headers});

        return options;
    }
    http_get(api_url): Observable<any> {
        return this.http.get(myGlobals.apiUrl + api_url, this.token_middleware())
            .map((res: Response) => {
                return res;
            }).catch((error: any) => {
                if (error.status === 401) {
                    localStorage.clear();
                    return Observable.throw('Unauthorized');
                } else {
                    return (this.callApiCatch(error));
                }
            });
    }
    //
    //  http_put(api_url,data){
    //      return this.http.put(api_url, data,this.token_middleware())
    //        .map((res: Response) => {
    //          return (this.callApi(res));
    //        }).catch((error: any) => {
    //          return (this.callApiCatch(error));
    //        });
    //  }
    //
    http_post(api_url, data): Observable<any> {
        return this.http.post(myGlobals.apiUrl + api_url, data, this.token_middleware())
            .map((res: Response) => {
                return res;
            }).catch((error: any) => {
                if (error.status === 401) {
                    localStorage.clear();
                    return Observable.throw('Unauthorized');
                } else {
                    return (this.callApiCatch(error));
                }

            });
    }
    //
    //  http_post_noauth(api_url,data){
    //      return this.http.post(api_url, data)
    //        .map((res: Response) => {
    //          return (this.callApi(res));
    //        }).catch((error: any) => {
    //          return (this.callApiCatch(error));
    //        });
    //  }
    //
    //  http_delete(api_url) {
    //    return this.http.delete(api_url,this.token_middleware())
    //      .map((res: Response) => {
    //        return (this.callApi(res));
    //      }).catch((error: any) => {
    //        return (this.callApiCatch(error));
    //      });
    //  }
    callApi(res) {
        if (res) {
            if (res.status === 201) {
                return {status: res.status, json: res.json()}
            }
            else if (res.status === 200) {
                return {status: res.status, json: res.json()}
            }
        }
    }
    //
    callApiCatch(error) {
        if (error.status === 500) {
            return Observable.throw(new Error(error.status));
        }
        else if (error.status === 400) {
            this.router.navigate(['/admin/login']);
            return Observable.throw(new Error(error.status));
        }
        else if (error.status === 401) {
            this.router.navigate(['/admin/login']);
            return Observable.throw(new Error(error.status));
        }
        else if (error.status === 404) {
            return Observable.throw(new Error(error.status));
        }
        else if (error.status === 409) {
            return Observable.throw(new Error(error.status));
        }
        else if (error.status === 406) {
            return Observable.throw(new Error(error.status));
        }
    }

}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/_services/api.service.ts